/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Back_To_Login_ButtonInputs */

const en_login_back_to_login_button = /** @type {(inputs: Login_Back_To_Login_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to Login`)
};

const fr_login_back_to_login_button = /** @type {(inputs: Login_Back_To_Login_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retour à la Connexion`)
};

const de_login_back_to_login_button = /** @type {(inputs: Login_Back_To_Login_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zurück zur Anmeldung`)
};

const it_login_back_to_login_button = /** @type {(inputs: Login_Back_To_Login_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Torna al login`)
};

const ru_login_back_to_login_button = /** @type {(inputs: Login_Back_To_Login_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вернуться к входу`)
};

const es_login_back_to_login_button = /** @type {(inputs: Login_Back_To_Login_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volver al inicio de sesión`)
};

const zh_cn2_login_back_to_login_button = /** @type {(inputs: Login_Back_To_Login_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`返回登录`)
};

const ja_login_back_to_login_button = /** @type {(inputs: Login_Back_To_Login_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ログインに戻る`)
};

const hi_login_back_to_login_button = /** @type {(inputs: Login_Back_To_Login_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लॉगिन पर वापस जाएं`)
};

const pt_pt2_login_back_to_login_button = /** @type {(inputs: Login_Back_To_Login_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voltar ao login`)
};

/**
* | output |
* | --- |
* | "Back to Login" |
*
* @param {Login_Back_To_Login_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_back_to_login_button = /** @type {((inputs?: Login_Back_To_Login_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Back_To_Login_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_login_back_to_login_button(inputs)
	if (locale === "de") return de_login_back_to_login_button(inputs)
	if (locale === "it") return it_login_back_to_login_button(inputs)
	if (locale === "ru") return ru_login_back_to_login_button(inputs)
	if (locale === "es") return es_login_back_to_login_button(inputs)
	if (locale === "zh-CN") return zh_cn2_login_back_to_login_button(inputs)
	if (locale === "ja") return ja_login_back_to_login_button(inputs)
	if (locale === "hi") return hi_login_back_to_login_button(inputs)
	if (locale === "pt-PT") return pt_pt2_login_back_to_login_button(inputs)
	return en_login_back_to_login_button(inputs)
});